import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../NavigationContainer.vue";
import { useRouter } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const goToPage = () => {
  router.push({ path: "/AddUser" });
};

const __returned__ = { router, goToPage, Navigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})